module.exports = __webpack_public_path__ + "static/img/ESGS2023TW.882d514.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ESGS2023TW.png
// module id = lTpz
// module chunks = 1